<template>
  <div class="answers" @click="continueStep">
    <v-navbar
      v-if="quiz.customer"
      :logo="quiz.customer.logo"
      :darkMode="quiz.dark_mode > 0"
      class="answers__header"
    />
    <v-lottie
      :options="talkOptions"
      height="34vw"
      width="34vw"
      class="answers__animation-talk"
      ref="refTalk"
    />

    <p class="answers__title">
      {{ quiz.start_message }} 
    </p>

    <v-lottie
      :options="pulseOptions"
      height="20vw"
      width="20vw"
      class="answers__animation-pulse"
      ref="refPulse"
    />
  </div>
</template>

<script>
import * as talkAnimation from "@/assets/animations/talk-animation.json";
import * as pulseAnimation from "@/assets/animations/pulse-animation.json";
import { mapActions, mapState, mapMutations } from "vuex";
import VLottie from "@/components/VLottie.vue";

export default {
  name: "CreateRespExterno",
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    finishMount: false,
    talkOptions: {
      animationData: talkAnimation,
      autoplay: false,
      loop: true
    },
    pulseOptions: {
      animationData: pulseAnimation,
      autoplay: false,
      loop: true
    }
  }),
  components: {
    VLottie,
    VNavbar: () => import("./components/VNavbar.vue")
  },
  computed: {
    ...mapState("Quiz", ["quiz"])
  },
  async mounted() {
    setTimeout(() => {
      this.$refs.refTalk.play();
      this.$refs.refPulse.play();
    }, 200);
    await this.getQuiz(this.id);
    this.finishMount = true;
  },
  methods: {
    ...mapActions("Quiz", ["getQuiz"]),
    ...mapMutations("Quiz", [
      "updateSequence",
      "updateAmountQuestions",
      "updateQuestion"
    ]),
    continueStep() {
      if (this.finishMount) {
        const { questions } = this.quiz;

        const sequence = questions.map((val, index) => ({
          ...val,
          position: index
        }));

        this.updateSequence(sequence);

        this.updateAmountQuestions(sequence.length - 1);

        this.updateQuestion(sequence[0]);

        this.$router.push({
          name: "responder-questionario-externo",
          params: { id: this.id }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.answers {
  height: 100vh;
  background: #eceff1;
  display: flex;
  flex-direction: column;
  align-items: center;
  & > &__header {
    width: 100%;
    margin-bottom: 24px;
  }
  &__animation-talk {
    margin-bottom: 56px;

    @media #{$large-and-up} {
      max-width: 10%;
      font-size: 2vw;
    }
  }
  &__title {
    max-width: 728px;
    font-size: 5vw;
    text-align: center;
    color: #242424;
    margin: 0 0 16px 0;
    padding: 0 24px;
    @media #{$small-and-down} {
      font-size: 24px;
    }
    @media #{$large-and-up} {
      margin: 0 0 56px 0;
      font-size: 2vw;
    }
  }
}
</style>
